import {CircleButton} from "Ncontracts.Common.UI";
import VendorConcentrationMap from "./VendorConcentrationMap";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import React, {Component} from 'react';
import "./_style.scss";
import {imageCdnUrls} from "../common/ImageCdnUrls";
import VendorConcentrationMapFilter from "./VendorConcentrationMapFilter";
import {fetchAllVendors, getFilterList} from "../../actions/vendors/vendorConcentrationMapAction";
import {getMapOverlays, toggleMapOverlay} from "../../actions/maps/mapOverlayAction";
import * as PropTypes from "prop-types";
import {MapVendorModel, VendorFilterModel} from "../../Models/vendors/VendorModel";
import CovidLegend from "./CovidLegend";
import mapOverlayService from "../../services/MapOverlayService";
import MAP_OVERLAYS from "../../constants/mapOverlays";
import isEmpty from "../../helpers/isEmpty";
import {givenTimeToLocalTime} from "../../reducers/dateTimeHelpers";


class VendorConcentrationMapContainer extends Component {

    static propTypes = {
        fetchAllVendors: PropTypes.func,
        filterOptions: PropTypes.arrayOf(Object),
        getFilters: PropTypes.func,
        getMapOverlays: PropTypes.func,
        toggleFilterPanel: PropTypes.func,
        vendorFilterList: PropTypes.shape(VendorFilterModel),
        vendorList: PropTypes.arrayOf(PropTypes.shape(MapVendorModel)),
        toggleMapOverlay: PropTypes.func,
        activeMapOverlayId: PropTypes.number
    };

    constructor(props) {
        super(props);
        this.infoWindow = undefined;
        this.props.fetchAllVendors(this.props.filterOptions);
        const title = this.handleInitialFilter();
        this.props.getFilters();
        this.props.getMapOverlays();

        this.state = {
            ...title,
            isFilterModalShowing: false,
            filterButtonContainerStyle: "level-right",
            filterIconStyle: "injected icon filter-icon filterIcon",
            filterIconButtonStyle: "button svg-button"
        };
    }

    toggleFilterPanel = () => {
        const {isFilterModalShowing} = this.state;

        this.setState({
            isFilterModalShowing: !isFilterModalShowing
        });

        isFilterModalShowing ? this.setState({
            filterButtonContainerStyle: "level-right",
            filterIconStyle: "injected icon filter-icon filterIcon",
            filterIconButtonStyle: "button svg-button"
        }) : this.setState({
            filterButtonContainerStyle: "level-right filterButtonContainerHidden",
            filterIconStyle: "injected icon filter-icon filterIconStyle",
            filterIconButtonStyle: "button svg-button filterButtonStyle"
        });
    };

    renderFilterButton = () =>
        this.state.showFilterButton === true
            && <CircleButton
                    data-tooltip="Filter"
                    className={`level-item ${this.state.showFilterButton ? "tooltip is-tooltip-bottom" : ""}`}
                    onClick={this.toggleFilterPanel}
                    isOpen={!this.state.showFilterButton}
                >
                    <img src={imageCdnUrls.filter} width="25" height="25"/>
                </CircleButton>;

    handleInitialFilter = () => {
        return {
            ...this.state,
            title: "Vendor Concentration",
            showFilterButton: true,
        };
    };

    renderMapOverlay = (map, maps) => {
        const closure = this;
        const mapOverlay = closure.props.activeMapOverlayId;
        const removeOverlay = closure.props.activeMapOverlayId == MAP_OVERLAYS.NONE;
        this.setState({isLoading: true});

        if(removeOverlay) {
            map.data.setStyle({visible: false});
            this.shiftMapSlightly(map, maps);
        }
        else {
            //event listeners must be removed when toggling between Map Overlays
            maps.event.clearListeners(map.data, 'mouseover');
            maps.event.clearListeners(map.data, 'mouseout');

            mapOverlayService.fetchMapOverlay(mapOverlay).then(data => {
                map.data.addGeoJson(data);
                this.setMapStyles(map);
                this.shiftMapSlightly(map, maps);

                //this will need to be reworked as we introduce more map overlays
                if(mapOverlay == MAP_OVERLAYS.FIRE_PERIMETER || mapOverlay == MAP_OVERLAYS.TROPICAL_WEATHER){
                    this.attachMouseoverTooltipsToMapFeatures(map, maps, mapOverlay);
                }
            });
        }
    }

    attachMouseoverTooltipsToMapFeatures(map, maps, mapOverlayId){
        const closure = this;
        closure.map = map;
        closure.maps = maps;

        closure.infoWindow = new closure.maps.InfoWindow({
            pixelOffset: new maps.Size(0, -35) // ensures tooltip is above pin to avoid flicker on mouseout
        });

        closure.map.data.addListener('mouseover', (event) => {
            const infoWindowContent = closure.buildInfoWindowContent(event.feature, mapOverlayId);
            closure.infoWindow.setContent(infoWindowContent);
            closure.infoWindow.setPosition(event.latLng);
            closure.infoWindow.open(closure.map);

            closure.map.data.addListener('mouseout', function () {
                closure.infoWindow.close();
            });
        });
    }

    buildInfoWindowContent = (feature, mapOverlayId) => {
        if (mapOverlayId == MAP_OVERLAYS.FIRE_PERIMETER){
            return this.getFirePerimeterInfoWindowContent(feature);
        }

        else if (mapOverlayId == MAP_OVERLAYS.TROPICAL_WEATHER){
            return this.getTropicalWeatherInfoWindowContent(feature);
        }
    }

    getFirePerimeterInfoWindowContent = (feature) => {
        const incidentName = feature.getProperty('name');
        const createDate = feature.getProperty('rfill');

        const incidentNameContent = !isEmpty(incidentName)
            ? `<div class="iw-metadata-row"><span class="iw-metadata-label">Incident Name: </span>
                <span>${incidentName}</span></div>`
            : "";

        const createdDateContent = !isEmpty(createDate)
            ? `<div class="iw-metadata-row"><span class="iw-metadata-label">Started: </span>
                <span>${givenTimeToLocalTime(createDate)}</span></div>`
            : "";

        return (
            `<div>
                ${incidentNameContent}
                ${createdDateContent}
            </div>`
        );
    }

    getTropicalWeatherInfoWindowContent = (feature) => {
        const prob7Day = feature.getProperty('prob7Day');
        const risk7Day = feature.getProperty('risk7Day');
        const activeStorm = feature.getProperty('nhc_Active_Storm');
        let infoWindowContent = ``;

        if(activeStorm)
        {
            infoWindowContent = (
                `<div class="iw-metadata-row">
                <span class="iw-metadata-label">Active Storm</span>
                </div>`
            );
        }
        else
        {
            const probabilityContent = !isEmpty(prob7Day)
            ? `<div class="iw-metadata-row"><span class="iw-metadata-label">7 Day Probability: </span>
                <span>${prob7Day}</span></div>`
            : "";

            const riskContent = !isEmpty(risk7Day)
                ? `<div class="iw-metadata-row"><span class="iw-metadata-label">7 Day Risk Projection: </span>
                    <span>${risk7Day}</span></div>`
                : "";

            infoWindowContent = (
                `<div>
                    ${probabilityContent}
                    ${riskContent}
                </div>`
            );
        }        

        return infoWindowContent;
    }

    setMapStyles = (map) => {
        map.data.setStyle(function(feature) {
            const customProperties = feature.getProperty('customFeatureProperties');
            return {
              fillColor: customProperties.fillColor,
              fillOpacity: customProperties.fillOpacity,
              strokeColor: customProperties.strokeColor,
              strokeOpacity: customProperties.strokeOpacity,
              strokeWeight: customProperties.strokeWeight
            };
        });
    }

    shiftMapSlightly(map, maps) {
        // shift the map a bit to trigger a new 'idle' event for google maps to emit
        const latitude = map.getCenter().lat();
        const longitude = map.getCenter().lng();
        map.setCenter(new maps.LatLng(latitude, longitude + .000000001));
    }

    mapVendorsToMarkers() {
        return this.props.vendorList;
    }

    render() {
        return (
            <div className="vendor-concentration-container">
                <div className="landing-page">
                    {this.state.isFilterModalShowing
                     && <VendorConcentrationMapFilter
                         filterOptions={this.props.vendorFilterList}
                         toggleFilterPanel={this.toggleFilterPanel}
                     />}
                    <div className="level header-container">
                        <div className="page-title level-left">Vendor Concentration</div>
                        <div className={this.state.filterButtonContainerStyle}>
                            {this.renderFilterButton()}
                        </div>
                    </div>
                    <VendorConcentrationMap
                        vendorList={this.mapVendorsToMarkers()}
                        renderMapOverlay = {this.renderMapOverlay}
                        activeMapOverlayId={this.props.activeMapOverlayId}
                    >
                        {this.props.activeMapOverlayId == MAP_OVERLAYS.COVID && <CovidLegend/>}
                    </VendorConcentrationMap>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    vendorList: state.vendors.vendorList,
    vendorFilterList: state.vendors.vendorFilterList,
    activeMapOverlayId: state.mapOverlays.activeMapOverlayId
});

function mapDispatchToProps(dispatch) {
    return {
        getFilters: () => dispatch(getFilterList()),
        getMapOverlays: () => dispatch(getMapOverlays()),
        fetchAllVendors: (filter) => dispatch(fetchAllVendors(filter)),
        toggleMapOverlay: (activeMapOverlayId) => dispatch(toggleMapOverlay(activeMapOverlayId))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VendorConcentrationMapContainer));
